// JSON.stringify keeps `</script>` and U+2028/2029 as-is, so a value could close the inline script.
const INLINE_SCRIPT_UNSAFE_CHAR_PATTERN = /[<>&\u2028\u2029]/g;

const INLINE_SCRIPT_CHAR_ESCAPES: Record<string, string> = {
  '<': '\\u003c',
  '>': '\\u003e',
  '&': '\\u0026',
  '\u2028': '\\u2028',
  '\u2029': '\\u2029',
};

export const toInlineScriptJson = (value: unknown) =>
  JSON.stringify(value).replace(
    INLINE_SCRIPT_UNSAFE_CHAR_PATTERN,
    (char) => INLINE_SCRIPT_CHAR_ESCAPES[char],
  );
